import React, {useCallback} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import {connect} from "react-redux";
import {hideDisassociateModal, startDisassociateCompany} from "features/modals/company/disassociate/reducer";
import {disassociateModalError, disassociateModalLoading} from "features/modals/company/disassociate/selectors";
import {Icon} from "features/components/icon";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import Button from "features/components/button";

/* istanbul ignore next */
const mapStateToProps = state => ({
    error: disassociateModalError(state),
    loading: disassociateModalLoading(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    hideDisassociateModal,
    startDisassociateCompany
};

export const DisassociateCompanyModal = (props) => {
    const {error, loading, hideDisassociateModal, startDisassociateCompany} = props;

    const doDisassociate = useCallback(() => {
        startDisassociateCompany();
    }, [startDisassociateCompany]);
    const doCancel = useCallback(() => {
         hideDisassociateModal();
    }, [hideDisassociateModal]);

    return <ModalPortal className="disassociate-company-modal">
        <Icon>link</Icon>
        <Title size={24} align={"center"}>{__("modal.disassociate-company.title")}</Title>
        <Text size={16} align={"center"}>{__("modal.disassociate-company.text")}</Text>
        {error.inError && <Text size={16} color={"danger"}>{__(error.error)}</Text>}
        <Button title={__("buttons.do-disassociate-company")} status={loading ? "loading" : "danger"} onClick={doDisassociate} icon={"arrow-right"} />
        <Button title={__("buttons.cancel")} type={"outlined"} onClick={doCancel} />
    </ModalPortal>
};
DisassociateCompanyModal.propTypes = {
};
export default connect(mapStateToProps, mapDispatchToProps)(DisassociateCompanyModal);